import React, { createContext, useState, useContext } from 'react'

const TabContext = createContext()

export const TabProvider = ({ children, initialTab = null }) => {
  const [activeTab, setActiveTab] = useState(initialTab)

  const value = {
    activeTab,
    setActiveTab
  }

  return (
    <TabContext.Provider value={value}>
      {children}
    </TabContext.Provider>
  )
}

export const useTabContext = () => {
  const context = useContext(TabContext)
  if (!context) {
    throw new Error('useTabContext must be used within a TabProvider')
  }
  return context
}

export default TabContext